import { IDS } from '../requirements-assessment-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from '../requirements-assessment.actions';

import {GRID_RELOAD} from "../../../../common/grid/grid.constants";
class EvidenceGroupHistoryGridController extends GridController {
    constructor($ngRedux,
                $state,
                NavigationService,
                AuthService,
                FileActions,
                $filter,
                $mdDialog,
                $scope
    ) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.rcoRequirementsAssessment;
        this.statePath = IDS.rcoEvidenceGroupHistoryGrid;
        // this.autoload = false;
        // this.filterControls = false;
        this.exportComponent = false;
        this.filterExpandButtonVisible = false
        // this.filterComponent = false;
        // this.header = false;
        this.icon = false;
        this.title = 'Review History';

        const user = this.AuthService.getUser();
        this.isAdmin = user.type === 'Administrator';
        this.basicTypeName = user.basicTypeName;
        this.columns = [
            // {title: '#', mapper: null},
            {title: this.$filter('translate')('COMMON.FIELD.CREATED_AT'),       mapper: 'date'},
            {title: this.$filter('translate')('COMMON.DATE.TIME'),              mapper: 'time'},
            {title: this.$filter('translate')('COMMON.FIELD.CREATED_BY'),       mapper: 'created_by'},
            {title: this.$filter('translate')('COMMON.FIELD.EVENT'),            mapper: 'eventType'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper: 'assignee'},
            {title: this.$filter('translate')('COMMON.DOCUMENT.NAME'),          mapper: 'name'},
            {title: this.$filter('translate')('COMMON.DOCUMENT.VERSION'),       mapper: 'version'},
            {title: this.$filter('translate')('COMMON.FIELD.TASK_NUMBER'),      mapper: 'task_number'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),           mapper: 'statusName'},
            // {title: this.$filter('translate')('COMMON.FIELD.LAST_CHANGE'),      mapper: 'last_modified'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), {...Actions, ...this.FileActions})(this);

        this.buttons.push(
            // {
            //     name: 'resend_notification',
            //     class: 'btnGridModify',
            //     label: this.$filter('translate')('COMMON.BUTTON.NOTIFY'),
            //     callback: ({$event}) => {
            //         const {uta_id} = $event.item;
            //         this.resendTaskNotification(uta_id);
            //     },
            //     filter: item =>  !!item.task_type_code
            // },
            {
                name: 'download_version',
                class: 'btnGridAction',
                label: this.$filter('translate')('COMMON.BUTTON.DOWNLOAD'),
                callback: ({$event}) => {
                    const {doc_uri} = $event.item;
                    this.download(`storage${doc_uri}`);
                },
                filter: item => !!item.doc_uri
            }
        );

        this.dataAction = this.fetchEvidenceGroupHistory;
        this.init();
    }

    $onDestroy() {
        // this.unsubscribe();
        this.destroy();
    }
}

EvidenceGroupHistoryGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', 'FileActions','$filter', '$mdDialog', '$scope'];

export const evidenceGroupHistoryGrid = {
    bindings: {
        adoId: '<',
    },
    controller: EvidenceGroupHistoryGridController,
    ...gridTpl
}
